<template>
  <template v-if="!disabled">
    <loading-item-cards :count="loadingCardCount" />
    <div ref="target"></div>
  </template>

  <template v-else-if="loading && !total">
    <loading-item-cards :count="loadingCardCount * 3" />
  </template>
</template>

<script>
import LoadingItemCards from '@components/Loading/LoadingItemCards.vue'
import { useIntersectionObserver } from '@vueuse/core'
import { useBrowseContainer } from '@composables'
import { onMounted, toRefs, ref } from 'vue'
export default {
  components: {
    LoadingItemCards,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  emits: ['fetch:more'],
  setup(props, { emit }) {
    const { loading, disabled } = toRefs(props)
    const target = ref(null)
    const { loadingCardCount } = useBrowseContainer()

    onMounted(() => {
      startIntersectionWatcher()
    })

    function startIntersectionWatcher() {
      const { stop } = useIntersectionObserver(
        target,
        ([{ isIntersecting }]) => {
          if (isIntersecting && !loading.value) {
            stop()
            if (!disabled.value) {
              emit('fetch:more')
              startIntersectionWatcher()
            }
          }
        }
      )
    }

    return {
      loadingCardCount,
      target,
    }
  },
}
</script>
